interface FooterSectionProps {
  lang: 'pt' | 'en';
}

export function FooterSection({ lang }: FooterSectionProps) {
  const footerText = lang === 'pt'
    ? '© 2026 SimplesFlow. Portugal. · Privacidade · Cookies'
    : '© 2026 SimplesFlow. Portugal. · Privacy · Cookies';

  return (
    <footer className="relative bg-black/50 backdrop-blur-sm" style={{ borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: '32px', paddingBottom: '32px' }}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Left: brand + copyright */}
          <div className="flex flex-col gap-1">
            <span className="text-white font-normal" style={{ fontSize: '14px', letterSpacing: '0.1em' }}>SimplesFlow</span>
            <span className="text-gray-500 font-light" style={{ fontSize: '12px' }}>{footerText}</span>
          </div>

          {/* Right: social icons */}
          <div className="flex items-center" style={{ gap: '20px' }}>
            <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center justify-center text-white/80 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-linkedin-line" style={{ fontSize: '22px' }}></i>
            </a>
            <a href="https://x.com" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center justify-center text-white/80 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-twitter-x-line" style={{ fontSize: '22px' }}></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center justify-center text-white/80 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-instagram-line" style={{ fontSize: '22px' }}></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
